import styled from 'styled-components';
import ErrorMessageComponent from 'components/error-message';
import { color, global, typography } from 'styles/settings';
import { withModifiers, normalize } from 'utils';

export const Container = styled.div`
  flex-direction: column;
  width: 100%;

  ${withModifiers('withForm')`
    margin-bottom: ${typography.size.md};
  `};
`;

export const TextInputContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: ${normalize(40)};
  justify-content: center;
  padding: 0 ${global.space.rg};
  ${withModifiers('primary')`
    background-color: ${color.neutral.grayLight};
    border-radius: ${global.radius.xs};
  `}

  ${withModifiers('secondary')`
    background-color: ${color.neutral.white};
  `}

  ${withModifiers('noUnderline')`  
    border-bottom-width: 0;
  `}
  
  ${withModifiers('multiline')`
    height: auto;
    padding: 0;
    margin: 0;
  `}
  
  ${withModifiers('invalid')`
    border: 1px solid ${color.ui.danger};
  `};

  ${withModifiers('isFocused')`
    
  `};

  ${withModifiers('disabled')`

  `};
`;

export const TextInput = styled.input`
  background-color: ${color.neutral.grayLight};
  border: none;
  color: ${color.neutral.black};
  flex: 1;
  height: ${normalize(25)};
  padding: 0;

  &:focus {
    outline: none;
  }

  &:active {
    outline: none;
  }

  ${withModifiers('primary')`
    ${typography.font.medium};
    font-size: ${typography.size.rg};
    line-height: ${typography.size.lg};
  `}

  ${withModifiers('secondary')`
    background-color: ${color.neutral.white};
  `}

  ${withModifiers('iconLeft')`
    padding-left: ${global.space.xs};  
  `};

  ${withModifiers('iconLeft')`
    padding-right: ${global.space.xs};
  `};

  ${withModifiers('multiline')`
    height: ${({ numberOfLines }) =>
      normalize(typography.size.lg) * numberOfLines};
    ${typography.font.medium};
    line-height: ${typography.size.lg};
    padding: ${global.space.sm} ${global.space.rg};
  `}

  ${withModifiers('noBorder')`
    border-width:0px;
    border:none;
    &:focus {
      outline:none;
    }
  `}
`;

export const Label = styled.span`
  color: ${color.neutral.grayDark};
  font-size: ${typography.size.rg};
  line-height: ${typography.size.md};
  margin-bottom: ${global.space.xs};
  ${withModifiers('invalid')`
    border-color: ${color.ui.danger};
    color: ${color.ui.danger};
  `};
`;

export const TextInputLabel = styled(Label)`
  ${withModifiers('primary')`
    color: ${color.neutral.white};
    font-size: ${typography.size.xs};
    ${typography.font.medium};
    text-transform: uppercase;
    padding-left: ${global.space.rg}; 
  `}

  ${withModifiers('secondary')`
    color: ${color.neutral.white};
    font-size: ${typography.size.md};
    ${typography.font.semiBold};
    margin-bottom: ${normalize('-4px')};
  `}

  ${withModifiers('multiline')`
    padding-left: ${global.space.rg}
  `}
`;

export const Icon = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: ${normalize(25)};
`;

export const Description = styled.span`
  color: ${color.ui.text};
  padding: ${normalize('10px')} 0;
`;

export const ErrorMessage = styled(ErrorMessageComponent)``;
